import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { getAgentAutonomyStyle } from '@/lib/mock-agents-data';

export function AutonomyBadge({ autonomy, className }: { autonomy: string | null | undefined; className?: string }) {
  const style = getAgentAutonomyStyle(autonomy);
  return (
    <Badge variant="outline" className={cn('text-[9px]', style.color, className)}>
      {style.label}
    </Badge>
  );
}
